<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import StepWizard from 'svelte-step-wizard';
	import FieldLoading from '../../../../../../shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../../../../shared/components/common/Loading/FormLoading.svelte';
	import Map from '../../../../../../shared/components/common/Map.svelte';
	import ConfirmModal from '../../../../../../shared/components/common/Modal/ConfirmModal.svelte';
	import SurveyReport from '../../../../../../shared/components/common/Survey/SurveyReport.svelte';
	import TitleCard from '../../../../../../shared/components/common/Title.svelte';
	import TabellaCalcoloEmissioniInput from '../../../../../../shared/components/mobilityPlatform/CalcoloEmissioni/TabellaCalcoloEmissioniInput.svelte';
	import TabellaCalcoloEmissioniOutput from '../../../../../../shared/components/mobilityPlatform/CalcoloEmissioni/TabellaCalcoloEmissioniOutput.svelte';
	import GraficoOrdinamentoCategorieMisura from '../../../../../../shared/components/mobilityPlatform/PSCL/GraficoOrdinamentoCategorieMisura.svelte';
	import TabellaImplementazioneMisure from '../../../../../../shared/components/mobilityPlatform/PSCL/TabellaImplementazioneMisure.svelte';
	import TabellaMisure from '../../../../../../shared/components/mobilityPlatform/PSCL/TabellaMisure.svelte';
	import TabellaMonitoraggioMisure from '../../../../../../shared/components/mobilityPlatform/PSCL/TabellaMonitoraggioMisure.svelte';
	import TabellaProgrammaComunicazione from '../../../../../../shared/components/mobilityPlatform/PSCL/TabellaProgrammaComunicazione.svelte';
	import TabellaProgrammaMonitoraggio from '../../../../../../shared/components/mobilityPlatform/PSCL/TabellaProgrammaMonitoraggio.svelte';
	import TabellaAltreInfo from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaAltreInfo.svelte';
	import TabellaAreeSostaRiservate from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaAreeSostaRiservate.svelte';
	import TabellaCapComuneDipendenti from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaCapComuneDipendenti.svelte';
	import TabellaIncentiviBuoniMobilita from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaIncentiviBuoniMobilita.svelte';
	import TabellaLocalizzazione from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaLocalizzazione.svelte';
	import TabellaOffertaTrasporto from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaOffertaTrasporto.svelte';
	import TabellaOrarioLavoro from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaOrarioLavoro.svelte';
	import TabellaPersonaleDipendente from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaPersonaleDipendente.svelte';
	import TabellaRisorseGestioneMobilita from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaRisorseGestioneMobilita.svelte';
	import TabellaServiziTrasporto from '../../../../../../shared/components/mobilityPlatform/Sede/Tables/TabellaServiziTrasporto.svelte';
	import { formatDateTime } from '../../../../../../shared/functions';
	import { PSCLSchemaBase } from '../../../../../../shared/models/PSCL/Schema/PSCLSchemaBase';

	let [data, loading, error] = PSCLSchemaBase.get();
	let [dataPSCLSchemaVersioni, loadingPSCLSchemaVersioni, errorPSCLSchemaVersioni] = PSCLSchemaBase.getList();
	
	$: selectedVersion = $data;

	let openConfirmDeleteDialog: boolean = false;

	function onSubmit() {
		[data, loading, error] = PSCLSchemaBase.save($data);
		data.subscribe((value) => {
			if (value) {
				[dataPSCLSchemaVersioni, loadingPSCLSchemaVersioni, errorPSCLSchemaVersioni] = PSCLSchemaBase.getList();
			}
		});
	}

async function onDelete() {
    try {
        let [dataEliminazione, loadingEliminazione, errorEliminazione] = await PSCLSchemaBase.delete($data.id);

        // Subscribe to the dataEliminazione
        dataEliminazione.subscribe((value) => {
            if (value.response) {
                [data, loading, error] = PSCLSchemaBase.get();
                [dataPSCLSchemaVersioni, loadingPSCLSchemaVersioni, errorPSCLSchemaVersioni] = PSCLSchemaBase.getList();
            }
        });
    } catch (e) {
        console.error("Error during deletion", e);
    }
}


	let stringifiedQuestionarioJson: string = `{"title":"Questionario sugli spostamenti casa-lavoro","logoPosition":"right","pages":[{"name":"Pagina1","elements":[{"type":"radiogroup","name":"Domanda1","title":"Dove si trova il suo domicilio abituale? (indichi il Comune)","isRequired":true,"choices":[{"value":"item1","text":"Comune 1"},{"value":"item2","text":"Comune 2"},{"value":"item3","text":"Comune 3"}],"showOtherItem":true,"otherText":"Altro (specificare)"},{"type":"text","name":"Domanda2","title":"Indichi il CAP del suo indirizzo di domicilio:","isRequired":true},{"type":"radiogroup","name":"Domanda3","title":"Indichi dove lavora:","isRequired":true,"choices":[{"value":"item1","text":"Sede 1"},{"value":"item2","text":"Sede 2"},{"value":"item3","text":"Sede 3"}]},{"type":"checkbox","name":"Domanda4","title":"Quale dei seguenti mezzi e abbonamenti ha a disposizione per spostarsi tra casa e il lavoro? [selezioni anche più di una risposta, se applicabile]","isRequired":true,"choices":[{"value":"item1","text":"Auto"},{"value":"item2","text":"Scooter, moto o microcar"},{"value":"item3","text":"Bicicletta"},{"value":"item4","text":"Monopattino"},{"value":"item5","text":"Abbonamento al trasporto pubblico (autobus, filobus, tram, metro, treno)"},{"value":"item6","text":"Abbonamento a servizi di mobilità condivisa (car sharing, bike sharing, scooter sharing o monopattini in sharing)"},{"value":"item7","text":"Nessuno di questi"}]},{"type":"radiogroup","name":"Domanda5","title":"Descrivi la sua attività lavorativa attuale:","isRequired":true,"choices":[{"value":"item1","text":"Mi sto recando presso la mia sede lavorativa tutti i giorni"},{"value":"item2","text":"Sto lavorando a volte in sede e a volte da casa"},{"value":"item3","text":"Sto lavorando sempre da casa"},{"value":"item4","text":"Non sto lavorando (ferie, congedi, aspettativa, ecc.)"}]}],"description":"Benvenuto/a nel questionario sugli spostamenti dedicato ai lavoratori e alle lavoratrici, proposto nell'ambito della redazione del Piano degli Spostamenti Casa-Lavoro (PSCL). Il breve questionario necessita del contributo di tutti per raccogliere il maggior numero possibile di informazioni. I risultati dell'indagine saranno utilizzati nella redazione del PSCL dell’azienda _________________, con vantaggi per i lavoratori e le lavoratrici attraverso l'incentivazione di modalità di spostamento più sostenibili. Grazie anticipatamente per la collaborazione, il gruppo di lavoro del PSCL."}],"locale":"it"}`;
</script>

<ConfirmModal bind:showModal="{openConfirmDeleteDialog}" onConfirm="{() => onDelete()}" />
<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<TitleCard title="PSCL Schema Base" />
	</div>
	<div class="grid grid-cols-2 p-4">
		<div class="justify-self-end flex items-center col-start-2 space-x-4">
			{#if $loading || $loadingPSCLSchemaVersioni}
				<FieldLoading />
			{:else}
				{#if $data?.id > 0 && $dataPSCLSchemaVersioni?.response?.length > 0}
					<Select key="{(PSCLSchema) => `${(PSCLSchema && PSCLSchema.id) || ''}`}" label="Versioni" bind:value="{selectedVersion}">
					{#each $dataPSCLSchemaVersioni.response as PSCLSchema (PSCLSchema.id)}
						{#if PSCLSchema.dataInsert}
						<Option value="{PSCLSchema}" on:click={() => $data = PSCLSchema}>
							{formatDateTime(PSCLSchema.dataInsert)}
						</Option>
						{/if}
					{/each}
					</Select>
					<button class="h-7.5 w-7.5" on:click={() => openConfirmDeleteDialog = true}>
						<span class="material-icons-outlined text-base leading-[1.8rem]">delete</span>
					</button>
				{/if}
			{/if}
		</div>		  
	</div>
	{#if $loading}
		<FormLoading customClass="pt-8" />
	{:else}
		{#if $data}
			<StepWizard initialStep="{1}">
				<StepWizard.Step num="{1}" let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="p-10 h-[70vh]">
						<div class="border-mobilityPlatform-green relative flex flex-col items-center justify-center h-full p-4 pb-20 border-t-2 border-b-2">
							<div class="flex flex-col items-center justify-center space-y-4">
								<div class="text-center">
									<span class="text-xl font-bold"><span class="bg-blue-100">Nome azienda</span> - <span class="bg-blue-100">Nome sede</span></span>
								</div>
								<div class="text-center">
									<span class="text-lg">Piano degli Spostamenti Casa-Lavoro</span>
								</div>
								<div class="mt-28 self-end w-full text-center">
								<p class="text-sm">
									<span class="bg-blue-100">Mese e anno di generazione del PSCL</span>
								</p>
								</div>
							</div>
							<div class="min-w-max absolute bottom-0 right-0 flex flex-col p-4 text-xs">
								<p class="text-base">A cura di</p>
								<p>nome e cognome del mobility manager</p>
								<p>Mobility manager <span class="bg-blue-100">nome azienda</span></p>
								<Input input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaIntroduzione.testoPrimaPagina} />
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{2}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 mr-2">
						<h1 class="text-3xl italic font-bold">
							<span>1.</span>
							<span>Introduzione</span>
						</h1>
						<div class="w-full mt-4">
							<Input textarea class="w-full" input$placeholder="Testo" input$rows={10} variant="filled" bind:value={$data.psclSchemaIntroduzione.testoIntroduzione} />
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{3}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>2.</span>
							<span>Parte informativa e di analisi</span>
						</h1>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.1</span>
								<span>Analisi delle condizioni strutturali dell'azienda e dell'offerta di trasporto</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaAnalisi.testoCondizioniStrutturali} />
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Localizzazione</h2>
										<TabellaLocalizzazione />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Personale dipendente</h2>
										<TabellaPersonaleDipendente />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Orario di lavoro</h2>
										<TabellaOrarioLavoro />
									</div>
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Risorse, servizi e dotazioni aziendali</h2>
										<h3 class="mb-2 text-xs text-center">Risorse per la gestione della mobilità dei dipendenti</h3>
										<TabellaRisorseGestioneMobilita />
										<h3 class="mt-2 mb-2 text-xs text-center">Servizi di trasporto per i dipendenti</h3>
										<TabellaServiziTrasporto />
										<h3 class="mt-2 mb-2 text-xs text-center">Incentivi / buoni mobilità per i dipendenti</h3>
										<TabellaIncentiviBuoniMobilita />
										<h3 class="mt-2 mb-2 text-xs text-center">Aree di sosta riservate ai dipendenti</h3>
										<TabellaAreeSostaRiservate />
										<h3 class="mt-2 mb-2 text-xs text-center">Altro</h3>
										<TabellaAltreInfo />
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.2</span>
								<span>Analisi dell'offerta di trasporto</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaAnalisi.testoOffertaTrasporto} />
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<h2 class="mb-2 text-sm font-bold text-center">Offerta di trasporto nei pressi della sede (distanza max 500 m)</h2>
										<TabellaOffertaTrasporto />
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>2.3</span>
								<span>Analisi degli spostamenti casa-lavoro</span>
							</h1>
							<Map latitude={41.8719} longitude={12.5674} zoom={6} customClass="mt-2"/>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>2.3.1</span>
									<span>Analisi delle modalità abituali di spostamento casa-lavoro e della propensione al cambiamento negli spostamenti casa-lavoro</span>
								</h1>
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaAnalisi.testoAbitudiniEPropensioneCambiamentoSpostamentoCasaLavoro} />
								<SurveyReport bind:stringifiedQuestionarioJson switchVisualization={false} printAnalytics={false} customClass="mt-2"/>
							</div>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>2.4</span>
									<span>Monitoraggio delle misure implementate</span>
								</h1>
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaMonitoraggioMisure.testoMonitoraggioMisure} />
								<div class="p-3">
									<TabellaMonitoraggioMisure />
								</div>
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{4}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>3.</span>
							<span>Parte progettuale</span>
						</h1>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.1</span>
								<span>Progettazione delle misure</span>
							</h1>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>3.1.1</span>
									<span>Descrizione delle misure da implementare</span>
								</h1>
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoMisureDaImplementareCategorieMisura} />
								<div class="flex justify-center mt-2">
									<div class="mt-2">
										<GraficoOrdinamentoCategorieMisura />
									</div>
								</div>
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoMisureDaImplementareMisure} />
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaMisure />
										</div>
									</div>
								</div>
							</div>
							<div class="w-full mt-4 ml-2">
								<h1 class="text-xl font-bold">
									<span>3.1.2</span>
									<span>Definizione dei benefici conseguibili con l'attuazione delle misure</span>
								</h1>
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoBeneficiMisureEmissioniInput} />
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaCalcoloEmissioniInput />
										</div>
									</div>
								</div>						  
								<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoBeneficiMisureEmissioniOutput} />
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaCalcoloEmissioniOutput />
										</div>
									</div>
								</div>							  
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.2</span>
								<span>Programma di implementazione</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoProgrammaImplementazione} />
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaImplementazioneMisure />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>3.3</span>
								<span>Programma di comunicazione</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaProgettazione.testoProgrammaComunicazione} />
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaProgrammaComunicazione />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</StepWizard.Step>
				<StepWizard.Step num="{5}" let:previousStep let:nextStep>
					<div class="grid grid-cols-2 p-4">
						<div class="justify-self-start col-start-1">
							<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
							</button>
						</div>
						<div class="justify-self-end col-start-2">
							<button type="submit" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{onSubmit}">
								<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
							</button>
						</div>
					</div>
					<div class="flex flex-col items-start justify-start p-4 ml-2">
						<h1 class="text-3xl italic font-bold">
							<span>4.</span>
							<span>Programma di monitoraggio</span>
						</h1>
						<div class="w-full mt-4">
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaMonitoraggio.testoProgrammaMonitoraggio} />
							<div class="w-full mt-4">
								<div class="flex justify-center mt-2">
									<div class="w-full">
										<div class="mt-2">
											<TabellaProgrammaMonitoraggio />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>4.1</span>
								<span>Aggiornamento del piano</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaMonitoraggio.testoAggiornamentoPiano} />
						</div>
						<div class="w-full mt-4 ml-2">
							<h1 class="text-2xl font-bold">
								<span>Appendice</span>
							</h1>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaAppendice.testoMatriceOD} />
							<div class="flex justify-center mt-2">
								<div class="w-full">
									<div class="mt-2">
										<TabellaCapComuneDipendenti />
									</div>
								</div>
							</div>
							<Input textarea class="w-full mt-4" input$placeholder="Testo" variant="filled" bind:value={$data.psclSchemaAppendice.testoQuestionarioRisposte} />
							<SurveyReport bind:stringifiedQuestionarioJson switchVisualization={false} printAnalytics={false} customClass="mt-2"/>
						</div>
					</div>
				</StepWizard.Step>
			</StepWizard>
		{/if}
	{/if}
</Card>
